import { defineRoute } from '@doordash/lib-routing'

export const ROOT = '/dasher'

export default {
  application: defineRoute(`${ROOT}/application/`),
  dasherlanding: defineRoute(ROOT),
  dasherSignup: defineRoute(`${ROOT}/signup/`),
  dasherflow: defineRoute(`${ROOT}/application/:uniqueLink/:step?`),
  fastPaySetup: defineRoute(
    `${ROOT}/application/:uniqueLink/dropshipping/fast-pay`
  ),
  drivingOpportunities: defineRoute(
    `${ROOT}/driving-opportunities/:slug?/:jobType?/`
  ),
  webview: defineRoute(`${ROOT}/webview/:sub?`),
  firstDash: defineRoute(`${ROOT}/first-dash/`),
  firstDashActivatedNoFirstDash: defineRoute(
    `${ROOT}/first-dash/activated-no-first-dash/`
  ),
  firstDashDash: defineRoute(`${ROOT}/first-dash/dash`),
  privacy: defineRoute(`${ROOT}/privacy/manage_account/`),
  privacyLogin: defineRoute(`${ROOT}/privacy/login`),
  deliveryDispute: defineRoute(`${ROOT}/delivery-issues/:id/dispute`),
  deliverySplash: defineRoute(`${ROOT}/delivery-issues/splash`),
  deliveryIssueList: defineRoute(`${ROOT}/delivery-issues`),
  deliveryIssueDetail: defineRoute(`${ROOT}/delivery-issues/:id`),
  deliveryIssuesExplanation: defineRoute(`${ROOT}/delivery-issues/explanation`),
  promotionsBankAccount: defineRoute(`${ROOT}/promotions/bank-account`),
  promotionsDownloadApp: defineRoute(`${ROOT}/promotions/download-app`),
  login: defineRoute(`${ROOT}/login`),
}
